var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarnetTextIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 76,
    viewBox: "0 0 87 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1686 0.880005H17.9735C8.04702 0.880005 0 8.42424 0 17.7305V59.0716C0 68.3779 8.04702 75.9221 17.9735 75.9221H68.1686C78.0951 75.9221 86.1422 68.3779 86.1422 59.0716V17.7305C86.1422 8.42424 78.0951 0.880005 68.1686 0.880005Z",
    fill: "#95C3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3287 46H15V49.5828H71.3287V46Z",
    fill: "#AED3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3287 56.5193H15V60.1021H71.3287V56.5193Z",
    fill: "#AED3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarnetTextIcon);
export default __webpack_public_path__ + "static/media/CarnetTextIcon.9c5e7bc3817cba2a1fb76a47a554249d.svg";
export { ForwardRef as ReactComponent };